import flatten from 'lodash/flatten';

/**
 * Retorna a chave/propriedade de um objeto que seja correspondente a um valor
 * @param {Object} object
 * @param {*} value
 */
export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

/**
 * Retorna uma lista com os objetos mais profundos do parent através da identificação
 * de uma propriedade do objeto mais profundo
 * @param {Object, Array} parent - Item a ser iterado
 * @param {String} deepestChildProperty - Propriedade utilizada para identificar o objeto filho
 * mais profundo
 */
export function getDeepestObjectsByProperty(parent, deepestChildProperty) {
  let deepestObjects = [];
  const fieldsToIterate = flatten(Object.values(parent));
  fieldsToIterate.forEach((item) => {
    if (item[deepestChildProperty]) {
      deepestObjects = deepestObjects.concat(item);
      return;
    }
    if (typeof item === 'object' || Array.isArray(item)) {
      deepestObjects = deepestObjects.concat(
        getDeepestObjectsByProperty(item, deepestChildProperty),
      );
    }
  });
  return deepestObjects;
}

export const valuesToArray = (obj) => {
  if (!obj) return null;
  const result = [];

  Object.keys(obj).forEach((sourceProperty) => {
    const value = obj[sourceProperty];
    if (value != null) {
      result.push(value);
    }
  });

  return result;
};
